import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AlloyButton, Table, Popup } from 'cat-ecommerce-alloy';
import { getTableSchema } from './TableSchema';
import { getCustomRenderers } from './utils';
import { INITIAL_REMAN_DATA, REMAN_TYPE } from './constants';
import { replaceTokensWithComponents } from '@app/utils';
import styles from './ProductRemanParts.module.scss';

const ProductRemanParts = ({ isPriceLoading, isPriceCall }) => {
  const [visibleParts, setVisibleParts] = useState(INITIAL_REMAN_DATA);
  const current = useSelector(s => s.products?.current);
  const tableData = useSelector(
    s => s.products?.byId?.[current]?.merchandisingAssociations
  );
  const priceAndAvailability = useSelector(
    s => s.products.priceAndAvailability
  );
  const remanTableData = tableData?.reduce((acc, item) => {
    if (item.associationType === REMAN_TYPE) {
      if (!priceAndAvailability?.[item.partNumber]?.totalPrice) {
        acc.push({
          ...item,
          isPriceLoading,
          isPriceCall,
          customCellClassNames: {
            addToCart: 'd-none d-md-none'
          },
          customCellProperties: {
            priceAvailability: {
              colSpan: 2
            }
          }
        });
      } else {
        acc.push({
          ...item,
          isPriceLoading,
          isPriceCall,
          customCellClassNames: {
            addToCart: 'd-md-table-cell'
          }
        });
      }
    }
    return acc;
  }, []);

  const [t] = useTranslation();
  const itemsIncludedSchema = getTableSchema();
  const getTableData = () => {
    return remanTableData.slice(0, visibleParts);
  };
  const popupContent = (
    <div className="u-fs--12">
      <p>{t('CAT_REMAN_VAL_STMT')}</p>
      <p>{t('CAT_REMAN_VAL_STMT_1')}</p>
    </div>
  );

  const popperOptions = { placement: 'bottom' };
  const initiator = (
    <AlloyButton buttonType="link" className="ps-0 pe-0">
      <span className="u-color--MediumBlue u-fs--14 p-0 ">
        {t('CAT_R_REMAN')}
      </span>
    </AlloyButton>
  );
  const loadMore = () => setVisibleParts(visibleParts + 2);
  const catRemenPopUp = () => (
    <Popup
      contents={popupContent}
      initiator={initiator}
      popperOptions={popperOptions}
      className="w-50"
    />
  );
  return remanTableData?.length > 0 ? (
    <div>
      <h4 className="h4 mb-0">{t('ALTERNATE_CAT_REMAN_TITLE')}</h4>
      <p className="u-fs-lg--14 mb-4">
        {replaceTokensWithComponents(
          t('ALTERNATIVE_CAT_REMAN_PARTS_DESC'),
          catRemenPopUp()
        )}
      </p>
      <Table
        schema={itemsIncludedSchema}
        data={getTableData()}
        customRenderers={getCustomRenderers()}
      />
      {visibleParts < remanTableData?.length && (
        <div className="text-center mt-3 position-relative">
          <AlloyButton
            className={`u-color--LightGray ${styles['load-more-button']}`}
            buttonType="tertiary"
            onClick={loadMore}
          >
            <span className="u-color--Black fw-bold u-fs--16 u-fs-md--14">
              {t('LOAD_MORE')}
            </span>
          </AlloyButton>
        </div>
      )}
    </div>
  ) : null;
};

ProductRemanParts.propTypes = {
  isPriceLoading: PropTypes.bool,
  isPriceCall: PropTypes.bool
};

export default ProductRemanParts;
